import { BreadcrumbItem } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { AuditBreadcrumbs } from './AuditBreadcrumbs';
import { auditConfigBreadcrumbItem, reportDefinitionsBreadcrumbItem } from './breadcrumb-items';

export interface ReportDefinitionsBreadcrumbsProps {
  reportType?: string;
  items?: readonly BreadcrumbItem[];
}

export function ReportDefinitionsBreadcrumbs({
  reportType,
  items = [],
}: ReportDefinitionsBreadcrumbsProps) {
  const { formatMessage } = useIntl();

  const baseItems: BreadcrumbItem[] = [
    auditConfigBreadcrumbItem(formatMessage),
    ...(reportType ? [reportDefinitionsBreadcrumbItem(formatMessage, reportType)] : []),
    ...items,
  ];

  return <AuditBreadcrumbs items={baseItems} />;
}
